/**
 * Safe HTML Utility - Sanitizes HTML using DOMPurify
 */

import DOMPurify from 'dompurify';

// Configure DOMPurify to allow safe HTML elements
const config = {
  ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 
                 'ul', 'ol', 'li', 'a', 'span', 'div', 'blockquote', 'code', 'pre'],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style'],
  ALLOW_DATA_ATTR: false,
};

/**
 * Sanitize HTML string for safe rendering
 */
export const sanitizeHtml = (dirty) => {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, config);
};

/**
 * Create safe props for dangerouslySetInnerHTML
 */
export const createSafeHtml = (html) => ({
  __html: sanitizeHtml(html)
});

export default sanitizeHtml;
